/**
 * @file components/log/weightCharts/WeightTrendChart.jsx
 * @description Actual weight vs trend line vs target goal.
 */

import {
  Area,
  AreaChart,
  CartesianGrid,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import {
  CHART_MARGIN,
  GRID_PROPS,
  X_AXIS_PROPS,
  Y_AXIS_PROPS,
} from "./chartUtils";
import { CustomTooltip } from "./chartUI";

export function WeightTrendChart({ data }) {
  return (
    <ResponsiveContainer width="100%" height={280} debounce={200}>
      <AreaChart data={data} margin={CHART_MARGIN}>
        <defs>
          <linearGradient id="colorWeight" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#10b981" stopOpacity={0.2} />
            <stop offset="95%" stopColor="#10b981" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid {...GRID_PROPS} />
        <XAxis dataKey="dateDisplay" {...X_AXIS_PROPS} />
        <YAxis {...Y_AXIS_PROPS} domain={["dataMin - 1", "dataMax + 1"]} />
        <Tooltip content={<CustomTooltip />} />
        <Area
          type="monotone"
          dataKey="weight"
          stroke="#10b981"
          strokeWidth={3}
          fill="url(#colorWeight)"
          dot={{ r: 4, fill: "#10b981", strokeWidth: 0 }}
          activeDot={{ r: 6 }}
          name="Actual Weight"
        />
        <Line
          type="monotone"
          dataKey="trend"
          stroke="#666"
          strokeDasharray="5 5"
          dot={false}
          strokeWidth={1.5}
          name="Trend Line"
        />
        <Line
          type="monotone"
          dataKey="goalWeight"
          stroke="#3b82f6"
          strokeDasharray="3 3"
          dot={false}
          strokeWidth={1}
          name="Target"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
